<hbo-datatable-smart *ngIf="packageTypes$ | async as packageTypes"
  [columns]="['package', 'licensesApp', 'defaultTestDays', 'privacy']" [items]="packageTypes"
  (reload)="searchPackageTypes($event)">
  <tbody class="table-group-divider accordion" id="accordionPackageType">
    <ng-container *ngFor="let packageType of packageTypes.data">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + packageType.id"> </button></th>
        <td>{{ packageType.name }}</td>
        <td>
          <ng-container *ngFor="let appPackage of (packageType.appPackages | sortArray:'appId'); let last = last">
            {{ appPackage.app.abbreviation }}<ng-container *ngIf="!last"> - </ng-container>
          </ng-container>
        </td>
        <td>{{ packageType.testDays }}</td>
        <td>{{ packageType.private ? 'Private' : 'Public' }}</td>
      </tr>
      <tr class="row-body">
        <td colspan="5" class="bg-light p-0">
          <div [id]="'collapse-' + packageType.id" class="accordion-collapse collapse"
            data-bs-parent="#accordionPackageType">
            <div class="accordion-body">
              <hbo-package-type-actions [packageType]="packageType"
                (reload)="searchPackageTypes()"></hbo-package-type-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!packageTypes.data.length">
      <td colspan="5" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>